import React from "react";
import PropTypes from "prop-types";
//import "./calendar-legend.scss";

const CalendarLegend = ({
    items = [],
    className = "",
    ariaLabel = "Calendar legend",
}) => {
    if (!Array.isArray(items) || items.length === 0) return null;

    return (
        <ul
            className={`calendar-legend ${className}`.trim()}
            aria-label={ariaLabel}
            role="list"
        >
            {items.map((item) => (
                <li key={item.key} className="legend-item" role="listitem">
                    <span
                        className={`legend-swatch legend-swatch--${item.key}`}
                        aria-hidden="true"
                    />
                    <small className="legend-label">{item.label}</small>
                </li>
            ))}
        </ul>
    );
};

CalendarLegend.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
};

export default CalendarLegend;
